import { MatchesViewer } from "components/MatchesViewer/MatchesViewer";
import { Panel } from "components/Panel/Panel";
import { Qualifier } from "model/Tournament/Segment/Qualifier/Qualifier";
import { Theme } from "model/Theme";
import { GrowColumn } from "pages/styles";

interface Props {
  qualifier: Qualifier;
  tournamentId: string;
  theme: Theme | undefined;
}

export const QualifierTabContent = ({
  qualifier,
  tournamentId,
  theme,
}: Props) => {
  return (
    <GrowColumn>
      <Panel>
        <MatchesViewer
          matchIds={qualifier.matchIds}
          tournamentId={tournamentId}
          hoverColor={theme?.secondary}
        />
      </Panel>
    </GrowColumn>
  );
};
